<template>
  <div class="landing-page-wrapper">
    <loading-overlay v-if="(isLoading || isCallback || !showContent) && !showErrorPage"></loading-overlay>
    <error-page v-if="showErrorPage"></error-page>
    <div class="container-fluid p-0" v-if="!showErrorPage" v-show="!isLoading && !isCallback">
      <enterprise-header
        :env="env"
        :login-on-load="loginOnLoad"
        :es-user-id-token="idToken"
        :user-country="userInfo.country"
        @onWebComponentSuccess="onWebHeaderComponentSuccess"
        @onAdditionalUserDataReady="handleAdditionalUserDataReady"
        @onUserInfoReady="handleUserInfoReady"
      ></enterprise-header>

      <main v-if="showContent || !loginOnLoad">
        <div class="row">
          <div class="col-12 text-center p-2 app-title mt-4 pb-0 pt-4">
            <div class="row">
              <div class="col-12" v-show="!isLoading">
                <h1 class="greeting-container">{{greeting}}</h1>
                <span v-if="!firstName">(You are not signed in)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-12">
            <enterprise-search
              :env="env"
              :key="searchComponentKey"
              :enable-url-params="true"
              :es-user-id-token="idToken"
              :user-country="userInfo.country"
              @onSearchKeywordChanged="onSearchKeywordChanged"
              input-placeholder="Search all of Autodesk"
              class="eh-search-container"
            ></enterprise-search>
          </div>
        </div>

        <div v-if="searchTerm.length == 0">
          <div class="row justify-content-left">
            <div class="offset-md-2 col-md-8">
              <div class="row">
                <div
                  v-for="app in apps"
                  :key="app.title"
                  class="col-md-4 col-sm-6 col-12 pr-0 pr-sm-5 box"
                >
                  <a :href="app.url" @click="onAppUrlClick(app)" :title="app.title">
                    <div class>
                      <div class="row m-0 mt-4">
                        <div class="col-12 justify-content-left">
                          <div class="app-container">
                            <img v-if="app.url" v-bind:src="app.logo" :class="app.logoClazz" />
                            <img
                              v-else
                              @click="handleFn(app.fn)"
                              v-bind:src="app.logo"
                              :class="app.logoClazz"
                            />
                          </div>
                          <div class="info-container text-center">
                            <a
                              v-if="app.url"
                              @click="onAppUrlClick(app)"
                              :href="app.url"
                              :title="app.title"
                            >{{app.title}}</a>
                            <a
                              v-else
                              href="javascript:void(0)"
                              @click="handleFn(app.fn)"
                              :title="app.title"
                            >{{app.title}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <div class="row m-0 justify-content-center">
                    <div class="col-8 p-md-0 pl-2 pr-2 text-center">
                      <div class="apps-description p-xs-x-10">{{app.description}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer class="footer landing-footer" v-show="showContent">
        <div class="footertext">
          © {{currentYear}} Autodesk Inc. All rights reserved &nbsp;|&nbsp;
          <span>
            <a @click="openAboutESModal" class="footer-link">About Enterprise Search</a> &nbsp;|&nbsp;
            <a target="_blank" :href="searchChannel" class="footer-link">#adsk-search</a>
          </span>
        </div>
      </footer>

      <div class="clear"></div>
      <div class="background-card" v-show="showContent">
        <div class="background-card-gradient" />
      </div>
      <modals-container />
    </div>
  </div>
</template>

<script>

require("../node_modules/bootstrap/dist/css/bootstrap.css");
require("../static/style.css");
import ManagePasswordModal from "@/components/ManagePasswordModal.vue";
import MixpanelMixin from "@/mixins/MixpanelMixin";
import CONSTANTS from "@/constants";
import LoadingOverlay from "./components/LoadingOverlay.vue";
import AboutEnterpriseSearch from "@/components/AboutEnterpriseSearch.vue";
import ErrorPage from "./components/ErrorPage";
export default {
  name: "app",
  data() {
    return {
      searchTerm: "",
      showErrorPage:false,
      isLoading: true,
      firstName: null,
      searchChannel:
        "https://autodesk.slack.com/archives/CEMQC8S2G",
      currentYear: new Date().getFullYear(),
      apps: CONSTANTS.APP_LIST,
      accessDashboardApp: {
        title: "Application and access dashboard",
        url: CONSTANTS.ACCESS_DASHBOARD_URL
      },
      searchComponentKey: 0,
      idToken: "",
      userInfo: {}
    };
  },
  watch: {
    searchTerm: function(val) {
      if (val) {
        document.body.className = "search-body";
      } else {
        document.body.className = "landing-body";
      }
    }
  },
  created() {
    this.checkIfRequestisFromSAMLError();
  },
  computed: {
    loginOnLoad() {
      return this.isSearchHost();
    },

    showContent() {
      if (this.isSearchHost() && this.firstName) {
        return true;
      } else if (!this.isSearchHost()) {
        // only when host is not search
        return !this.isLoading && !this.isCallback;
      } else {
        return false;
      }
    },

    isCallback() {
      return this.parseUrlParam(window.location.search, "code");
    },
    greeting() {
      return this.firstName ? "Welcome, " + this.firstName : "Welcome";
    },
    env() {
      return CONSTANTS.COMPONENT_ENV;
    },
  },
  methods: {
    checkIfRequestisFromSAMLError(){
      if(this.$route.query && this.$route.query.error == 'access_denied'){
       this.showErrorPage=true;
      }
    },
    parseUrlParam(url, name) {
      var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(url);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    },
    hasWhiteSpace(s) {
      return s.indexOf(" ") >= 0;
    },
    onWebHeaderComponentSuccess(response) {
      response = response.detail[0];
      if (response) {
        const mixPanelInstance = response.mixpanelInstance;
        if (mixPanelInstance) {
          this.mixPanelInstance = mixPanelInstance;
          this.trackMixpanelEvent(document.title);
        }

        if (response.user) {
          this.firstName = response.user.firstName;

          if (this.hasWhiteSpace(this.firstName)) {
            this.firstName = this.firstName.substr(
              0,
              this.firstName.indexOf(" ")
            );
          }
        }
      }
      //Force re-render the Enterprise Search component // commented the force rendering to eliminate the two calls for token generation
      //this.searchComponentKey++;
      this.isLoading = false;
    },

    isSearchHost() {
      let isLocal = window.location.hostname == "localhost"; //added this to act local as search.autodesk.com , if we need to debug for landing , change the condition below to !isLocal

      if (window.location.host.includes("search") || isLocal) {
        return true;
      } else {
        return false;
      }
    },
    onAppUrlClick(app) {
      this.trackMixpanelEvent(document.title, {
        subEvent: app.title,
        subEventUrl: app.url
      });

      return true;
    },
    onSearchKeywordChanged(response) {
      var responseDetail = response.detail[0];
      this.searchTerm = responseDetail;
    },
    handleFn(fn) {
      this[fn]();
    },
    openAboutESModal() {
      this.$modal.show(
        AboutEnterpriseSearch,
        {},
        {
          height: "auto",
          transition: "fade",
          scrollable: true,
          adaptive: true
        }
      );
    },
    openChangePwdModal() {
      this.onAppUrlClick({ title: "Password Management", url: "" });
      var propData = "";
      this.$modal.show(
        ManagePasswordModal,
        { propData },
        {
          height: "auto",
          transition: "fade",
          scrollable: true,
          adaptive: true
        }
      );
    },
    handleAdditionalUserDataReady(payload) {
      this.idToken = payload.detail[0].idToken;
    },
    handleUserInfoReady(payload) {
      this.userInfo = payload.detail[0];
    }
  },
  mixins: [MixpanelMixin],

  components: {
    ErrorPage,
    LoadingOverlay
  }
};
</script>

<style>
.landing-page-wrapper {
  background-color: #ffffff;
}
.landing-page-wrapper .navbar-collapse.collapse.show {
  width: inherit;
}
</style>

<style scoped>
.hh-header {
  background-color: #3c3c3c;
  min-height: 60px;
}

.app-title {
  color: #2f3642;
}

.box-container {
  width: 100%;
  min-height: 200px;
  max-height: 200px;

  border-radius: 3px;
  border: 1px solid #cecece;
  /*-webkit-box-shadow: 0 2px 5px 0 #888;
  box-shadow: 0 2px 5px 0 #888;*/
  -webkit-box-shadow: 0 5px 8px 0 #888;
  box-shadow: 0 5px 8px 0 #888;
  background-color: #fff;
}

.box {
  margin-bottom: 25px;
  padding-right: 8px;
  padding-left: 8px;
}

.app-container,
.app-container img {
  width: 50px;
  max-height: 50px;
}

.app-container {
  margin: auto;
  margin-top: 20px;
  margin-bottom: 5px;
  min-height: 50px;
}

.info-container {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 10px;
}
.info-container a {
  color: #5f60ff;
}


.info-container a:hover{
  color: #1F20BF;
}

main {
  /* pb-5 (48px) + footer size (52px)  */
  padding-bottom: 100px;
}

a.btn-lnk:hover {
  background-color: #0470a1;
}
a.btn-lnk {
  background-color: #5F60FF;
  display: inline-block;
  text-decoration: none;
  vertical-align: top;
  border-bottom: none !important;
  color: #fff !important;
  -webkit-transition: background-color 0.2s;
  -moz-transition: background-color 0.2s;
  -ms-transition: background-color 0.2s;
  -o-transition: background-color 0.2s;
  transition: background-color 0.2s;
  -webkit-box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  font-weight: 700;
  padding: 12px;
}

.apps-description {
  font-size: 16px;
  color: #64788d;
  font-weight: bold;
}

.footer .footertext,
.landing-footer .footertext {
  padding: 16px 25px;
  font-size: 16px;
  font-family: ArtifaktElementMedium !important;
}

.landing-footer {
  min-height: 52px;
  height: unset !important;
  width: 100%;
  border-top: 1px solid #fff;
  background: #000000;
  color: #fff;
  height: auto !important;
  display: flex;
  justify-content: center;
}

.footer-link {
  color: #2BC275 !important;
}

.flat-blue-btn {
  background: #fff;
  color: #5F60FF;
  border: 1px solid #5F60FF;
  border-radius: 0;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 14px;
  text-transform: uppercase;
  height: 45px;
  margin-bottom: 5px;
}

hr {
  border-top: 1px solid #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.rounded-logo {
  border-radius: 12px;
}
.applications-container {
  text-transform: uppercase;
  line-height: 1.4 !important;
  font-weight: 700;
}
.error-container {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: -webkit-gradient(linear, right top, left top, from(#32bcad), to(#048882)) !important;
  background: linear-gradient(270deg, #32bcad, #048882) !important;
  background: #32bcad;
  color: #fff;
}

.greeting-container {
  line-height: 0.6;
  color: #2f3642;
  font-size: 36pt;
  font-weight: bold;
  font-family: artifaktElementBold;
}

@media only screen and (max-width: 768px) {
  .greeting-container {
    font-size: 2rem;
  }

  .pt-15 {
    padding-top: 15px;
  }
}

@media only screen and (max-width: 767px) {
  .p-xs-x-10 {
    padding: 0px 15px 0px 10px;
  }
}

/*
CSS for search to reduce font-size as we're rendering col-md-8 on home page and col-md-6 here.
Below overrides ensure they're consistent.
*/

@media only screen and (min-width: 1200px) {
  .eh-search-container >>> .container-fluid .row .search-card-container:only-child {
    margin-left: 25% !important;
  }
}

.eh-search-container >>> .container {
    max-width: unset !important;
  }

.eh-search-container >>> .search-input-wrapper {
    margin-left: auto !important;
    margin-right: auto !important;
}
   
@media (min-width: 992px) {
  .eh-search-container >>> .search-card-container,
  .eh-search-container >>> .nav-bar-wrapper > .col-md-6 {
    max-width: 50% !important;
    margin-left: 25% !important;
    margin-right: auto !important;
    flex: 0 0 100% !important;
  }
}

</style>
<style>
.search-input {
  line-height: 25px !important;
  border: 1px solid #2f3642 !important;
}

.search-results-stats-card-txt {
  color: #000 !important;
}
</style>
